// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3ie3l","question":"Question_question__1wXky","description":"Question_description__1Poz7"};